import type { FaireProductEntity } from "../../entity_types/product";

export const p_tsbrw9tdfc: FaireProductEntity = {
  token: "p_tsbrw9tdfc",
  type: "product",
  name: "VW - Road Trips Shaped Tin",
  brandToken: "b_4ztdnlvzm9",
  brandName: "Eurographics Puzzles USA",
  imageUrl:
    "https://cdn.faire.com/fastly/be9b920807c84246af60f91814d2aeb6e705f9e56afb5cef057f9dee5c5c61ef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d73c93370b84fae8b62781cd249340390b388a2da036ff53c56d7ad3d810dc5.jpeg",
    "https://cdn.faire.com/fastly/70af09c36d7308b9214e0c3b6e26dd53b7f31e7b0b5a56bf9b136f33d7cda288.jpeg",
    "https://cdn.faire.com/fastly/3930194c966afcd7e179d0d80421a508432f44cd6f5425cb305515c244410118.jpeg",
    "https://cdn.faire.com/fastly/39d06ebb00d2d6541cf8e221e1d8056a5f848af40a55d71db4426c7f628328c0.jpeg",
    "https://cdn.faire.com/fastly/e88b4ee6a3c23e7e24b09a4b22bd4c8eaff591cf3e38c3d677465b37c9e8db84.jpeg",
  ],
  priceDollars: 16.63,
  description:
    "Eurographics VW - Road Trips Shaped Tin 550 piece Puzzle\n\nA collectible collage style puzzle celebrating the history of volkswagen bus. Puzzle stored inside VW bus shaped tin packaging. Licensed exclusive item. \n\nOFFICIALLY LICENSED PRODUCT\n\nPuzzle stored inside embossed tin packaging.\nPoster Included\nPrecision-Cut Pieces: Ensuring a snug fit and hours of relaxing enjoyment\nPremium Quality: Crafted with premium blueboard and a linen finish for a durable, glare-free experience.\nEco-Friendly: Manufactured using recycled and responsibly sourced materials.\nBox-Tin size: 10 x 4.75 x 4 in (25.4 x 12 x 10.2 cm)\nAges: 12+",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:10.585Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
